export const cars = [
  {
    id: 1,
    make: 'BMW',
    model: '3er-Reihe',
    year: 2018,
    month: 2,
    body: 'Limousine',
    mileage: 70000,
    fuel: 'Diesel',
    transmission: 'Automatik',
    condition: 'Gebrauchtwagen',
    drivetrain: 'Hinterrad',
    engine: '200KW',
    exterior: 'Silber',
    price: 28490,
    link: 'bmw.jpg',
    title: 'BMW 3er-Reihe 320d Gran Turismo Aut. (F34)**NUR 70.000 KM ** Lim',
    images: [
      'bmw_back.jpg',
      'bmw_dashboard.jpg',
      'bmw_front.jpg',
      'bmw_interior.jpg',
    ],
    features: [
      'ABS',
      'Alarmanlage',
      'Antriebsschlupfregelung (ASR)',
      'Beifahrerairbags',
      'Bluetooth-USB',
      'Bordcomputer',
      'elektr. Fensterheber',
      'elektr. Spiegel',
      'Fahrerairbag',
      'Freisprecheinrichtung',
      'ISOFIX',
      'Klimaanlage',
      'Klimaautomatik',
      'Kurvenfahrlicht',
      'Lederlenkrad',
      'Leichtmetall - Alufelgen',
      'Lichtsensor',
      'Media-Interface',
      'Mittelarmlehne',
      'Multifunktionslenkrad',
      'Navigationssystem',
      'Nebelscheinwerfer',
      'Notbremsassistent',
      'Parksensor hinten',
      'Radio',
      'Regensensor',
      'Reifendrucksensor',
      'Ruckfahrkamera',
      'Seitenairbags',
      'Servicegepflegt',
      'Servolenkung',
      'Sitzheizung',
      'Spurhalteassistent',
      'Stabilitetsprogramme (ESP)',
      'Tagfahrlicht',
      'Tempomat',
      'Zentralverriegelung',
      'Lederausstattung',
      'Metallic-Lackierung',
      'Sportfahrwerk',
      'Kopfairbags',
      'Panoramadach',
      'Schiebedach',
      'Anhngerkupplung',
      'Aut. Heckklappe',
      'Notrufsystem',
      'Parksensor vorne & hinten',
      'Schisack',
      'Start Stopp-Automatik',
      'Kollisionswarner',
      'Handy induktiv laden',
      'Head-Up-Display',
      'Keyless entry',
      'Komfortfahrwerk',
      'LED-Scheinwerfer',
      'Totwinkelassistent',
    ],
    description:
      '<p>*Terminvereinbarung Besichtigung und Probefahrt unbedingt erforderlich*</p><strong>* 2.BESITZ - NUR 70.000 KM *<br> * PICKERL UND SERVICE NEU BIS 02 2024 + 4 MONATE *\u00a0<p><strong>** TOP AUSSTATTUNG **<p>\u00a0<p><p><strong>LEDER ,AUTOMATIK , NAVI , HED - UP DISPLAY ,R\u00dcCKFAHRKAMERA , PARKSENSOREN ( VO & HI ) , PANORAMA SCHIEBEDACH , SPURHALTEASSISTENT , SPURFERLAS ASSISTENT , NOTBREMSASSISTENT , TOTER WINKEL ASSISTENT , ANH\u00c4NGERKUPPLUNG , START-STOP-SYSTEM , KEYLESS ENTRY SYSTEM , KOLLISIONSWARNER ,TEMPOMAT MIT GESCHWINDIGKEITSBEGRENZER , KLIMAAUTOMATIK , SERVO , ABS , ESP , EL.FH , ZV , EL.SP , RADIO , BERGANFAHRASSISTENT , USB AUX , BLUETOOTH , LED - TAGFAHRLICHT , MULTIFUNKTIONSLENKRAD , XENON usw...<p>\u00a0<p><strong>!!! SOFORT KREDIT !!!<br> SCHON AB 1 MONAT BESCH\u00c4FTIGUNG AUCH OHNE ANZAHLUNG M\u00d6GLICH FAST ALLE G\u00c4NGIGEN FINANZIERUNGSMODELLE, BEI PASSENDER BONIT\u00c4T ABWICKLUNG INERHALB 24h<p>\u00a0<p><strong>50 50 FINANZIERUNG MIT 0% ZINSEN<p><br> Anh\u00e4ngerkupplung (Kugelkopf schwenkbar)<br> Fahrassistenz-System: Spurwechsel-Warnsystem<br> Geschwindigkeits-Regelanlage mit Bremsfunktion<br> HiFi-Lautsprechersystem<br> Induktionsladeschale Smartphone (Wireless Charging)<br> Innenausstattung: Interieurleisten Alu L\u00e4ngsschliff fein mit Akzentleiste<br> Innovations-Paket<br> Instrumentenkombination (erweiterter Umfang)<br> Lenkrad (Sport Leder)<br> Metallic-Lackierung<br> Mittelarmlehne vorn verstellbar<br> Paketkombination: Business-Paket in Verbindung mit Navigations-Paket ConnectedDrive<br> Panoramadach (Glas)<br> Park-Distance-Control (PDC) vorn und hinten<br> Reifensystem Run-Flat (mit Notlaufeigenschaften)<br> R\u00fcckfahrkamera<br> Sicherheitssystem Active Protection<br> Sitzbezug   Polsterung: Leder Dakota<br> Sonnenschutzverglasung (hinten abgedunkelt)<br> Airbag Beifahrerseite abschaltbar<br> Airbag Fahrer- Beifahrerseite<br> Aktive Motorhaube<br> Aktiver Heckspoiler (elektrisch ausfahrbar)<br> Anti-Blockier-System (ABS)<br> Auspuffanlage (1-Rohr-Anlage) mit Blende<br> AUX-IN-Anschluss (AUX-IN)<br> Au\u00dfenspiegel elektr. verstell- und heizbar<br> Au\u00dfenspiegel Wagenfarbe<br> Blinkleuchten LED<br> Bordcomputer<br> Bremsassistent<br> Bremsenergier\u00fcckgewinnung (Rekuperationssystem)<br> Check-Control-System<br> Diebstahlsicherung R\u00e4der (Felgenschl\u00f6sser)<br> Drehzahlmesser<br> Durchladeeinrichtung (Mittelarmlehne hinten)<br> Dynamische Bremsleuchte<br> Dynamische Stabilit\u00e4ts-Control (DSC)<br> Fahrassistenz-System: Fahrerlebnisschalter<br> Farbmonitor (6,5 Zoll)<br> Fensterheber elektrisch vorn + hinten<br> Freisprecheinrichtung Bluetooth mit USB- Audio-Schnittstelle<br> Fu\u00dfmatten Velours<br> Gep\u00e4ckraumabdeckung   Rollo<br> Getriebe Automatik - (8-Stufen)<br> Heckklappenbet\u00e4tigung automatisch<br> Heckleuchten LED<br> Isofix-Aufnahmen Kindersitz an R\u00fccksitz<br> Karosserie: 5-t\u00fcrig<br> Klimaautomatik<br> Kopf-Airbag-System hinten<br> Kopf-Airbag-System vorn<br> Kopfst\u00fctzen hinten klappbar<br> Lenks\u00e4ule (Lenkrad) mechan. verstellbar<br> Licht- und Regensensor<br> LM-Felgen<br> Modellpflege<br> Motor 2,0 Ltr. - 140 kW 16V Turbodiesel<br> Nebelscheinwerfer<br> Nebelscheinwerfer LED<br> Nichtraucher-Paket<br> Personalisierungssystem (Personal Profile)<br> Reifendruck-Kontrollsystem<br> Reifenpannen-Anzeige<br> Ru\u00dfpartikelfilter<br> Schadstoffarm nach Abgasnorm Euro 6<br> Schaltpunktanzeige<br> Scheibenwaschd\u00fcsen heizbar<br> Seitenairbag hinten<br> Seitenairbag vorn<br> Service-System: ConnectedDrive Services<br> Service-System: Intelligenter Notruf inkl. TeleServices<br> Servolenkung Servotronic<br> Sitze vorn h\u00f6henverstellbar<br> Start-Stop-Knopf<br> Start Stop-Anlage (Funktion)<br> Sto\u00dff\u00e4nger Wagenfarbe<br> Wegfahrsperre<br> Zentralverriegelung mit Fernbedienung<p><br> !!! EINTAUSCH - UND FINANZIERUNGSM\u00d6GLICHKEIT !!!<br> Irrt\u00fcmer Zwischenverkauf Satz und Druckfehler vorbehalten< p>',
  },
  {
    id: 2,
    year: 2018,
    month: 6,
    body: 'Limousine',
    transmission: 'front-wheel',
    mileage: 24000,
    fuel: 'Diesel',
    price: 8000,
    title: 'Mercedes-Benz E220 **NUR 24.000 KM ** Lim',
    images: [
      'merc-front.jpg',
      'merc_back.jpg',
      'merc-interior.jpg',
      'merc-dashboard.jpg',
    ],
    link: 'merc220e.jpg',
    make: 'Mercedes-Benz',
    model: 'E220',
    condition: 'NEU',
    drivetrain: 'Hinterrad',
    engine: '200KW',
     exterior: 'Weiß',
    features: [
      'ABS',
      'Alarmanlage',
      'Antriebsschlupfregelung (ASR)',
      'Beifahrerairbags',
      'Bluetooth  USB',
      'Bordcomputer',
      'elektr. Fensterheber',
      'elektr. Spiegel',
      'Fahrerairbag',
      'Freisprecheinrichtung',
      'ISOFIX',
      'Klimaanlage',
      'Klimaautomatik',
      'Lederlenkrad',
      'Leichtmetall-Alufelgen',
      'Media-Interface  mp3',
      'Multifunktionslenkrad',
      'Nebelscheinwerfer',
      'Parksensor hinten',
      'Radio',
      'Regensensor',
      'Reifendrucksensor',
      'Ruckfahrkamera',
      'Seitenairbags',
      'Servicegepflegt',
      'Servolenkung',
      'Tempomat',
      'Zentralverriegelung',
      'Metallic-Lackierung',
      '8-fach Bereift',
      'Kopfairbags',
      'Aut. Heckklappe',
      'Parksensor vorne & hinten',
      'StartStopp-Automatik',
      'Abstandstempomat',
      'Kollisionswarner',
      'MwSt. ausweisbar',
    ],
    description:
      '<p><em>Terminvereinbarung für Besichtigung und Probefahrt unbedingt erforderlich</em></p><p><br><strong>1.BESITZ - 24.000 KM SERVICEBUCH</strong><br> PICKERL BIS 11 / 2023 + 4 MONATE<br><strong> SERVICE NEU </strong></p><p><strong>Mehrwertsteuer ausweisbar</strong></p><p><br><strong>NAVI , PARKSENSOREN (VO &amp; HI), SPURHALTEASSISTENT, KLIMAAUTOMATIK, TEMPOMAR, TATSCHSKRIM, START STOP AUTOMATIK, SITZHEIZUNG, LENKRADHEIZUNG</strong>, TEMPOMAT, FREISPRECHEINRICHTUNG, SERVO, SPRACHSTEUERUNG, ABS, ESP, EL.FH, ZV, RADIO &amp; USB AUX, BLUETOOTH, MULTIFUNKTIONSLENKRAD usw...</p><p><br><strong>!!! SOFORT KREDIT !!!</strong><br> SCHON AB 1 MONAT BESCHÄFTIGUNG AUCH OHNE ANZAHLUNG MÖGLICH FAST ALLE GÄNGIGEN FINANZIERUNGSMODELLE, BEI PASSENDER BONITÄT ABWICKLUNG INERHALB 24h</p><p><strong>***50/50 FINANZIERUNG MIT 0% ZINSEN***</strong></p><p><br> Audio-Navigationssystem Navi RF 900 Europa Touch (IntelliLink 8"-Display)<br> Ergonomiesitz vorn links<br> Frontkamera<br> Klimaautomatik 2-Zonen<br> Parkpilotsystem vorn und hinten<br> Perleffekt-Lackierung<br> Voll-LED (IntelliLux)<br> Winter-Paket<br> Airbag Fahrer-/Beifahrerseite<br> Außenspiegel elektr. verstell- und heizbar<br> Außenspiegel Wagenfarbe<br> Bluetooth Audio-Streaming<br> Bordcomputer<br> Bremsassistent<br> Dach, Design-Ausführung (Chrom)<br> Dachhimmel schwarz<br> Dachreling silber<br> Drehzahlmesser<br> Ecoflex<br> Elektrische Schnellheizung (Quickheat)<br> Elektron. Stabilitäts-Programm Plus (ESP)<br> Fahrassistenz-System: Berganfahr-Assistent (HSA, Hill Start Assist)<br> Fahrzeugschlüssel (2) beide klappbar<br> Fensterheber elektrisch vorn + hinten<br> Geschwindigkeits-Regelanlage (Tempomat)<br> Getriebe 6-Gang<br> Heckleuchten LED<br> Isofix-Aufnahmen für Kindersitz an Rücksitz<br> Karosserie: 5-türig<br> Kopf-Airbag-System<br> Laderaumabdeckung<br> Lenkrad (Leder)<br> Lenkrad mit Multifunktion<br> Lenksäule (Lenkrad) verstellbar<br> Licht-Paket<br> LM-Felgen<br> Mittelarmlehne vorn verschiebbar<br> Motor 1,6 Ltr. - 100 kW CDTI DPF<br> MP3-Schnittstelle für Mobiltelefon/Handy<br> Nebelscheinwerfer<br> OnStar SOS Service<br> Reifen-Reparaturkit<br> Reifendruck-Kontrollsystem<br> Rußpartikelfilter<br> Schadstoffarm nach Abgasnorm Euro 6<br> Seitenairbag vorn<br> Servolenkung geschwindigkeitsabhängig<br> Sicht-Paket<br> Start/Stop-Anlage<br> Steckdose (12V-Anschluss) in Mittelkonsole<br> Tagfahrlicht LED<br> Türgriffe außen Wagenfarbe<br> Wegfahrsperre<br> Wärmeschutzverglasung hinten abgedunkelt (Solar-Protect)<br> Zentralverriegelung mit Fernbedienung</p><p><br> !!! EINTAUSCH- UND FINANZIERUNGSMÖGLICHKEIT !!!<br> Irrtümer Zwischenverkauf Satz und Druckfehler vorbehalten</p>',
  },
  {
    id: 3,
    year: 2017,
    month: 8,
    body: 'Limousine',
    transmission: 'front-wheel',
    mileage: 154000,
    fuel: 'Diesel',
    price: 24000,
    title: 'Audi e-tron ** KLIMA - SITZHEIZUNG - LENKRADHEIZUNG** L',
    images: [
      'audi_back.jpg',
      'audi_dashboard.jpg',
      'audi_front.jpg',
      'audi_interior.jpg',
    ],
    link: 'audi.jpg',
    make: 'Audi',
    model: 'e-tron',
    condition: 'NEU',
    drivetrain: 'Hinterrad',
    engine: '190KW',
     exterior: 'Weiß',
    features: [
      'ABS',
      'Alarmanlage',
      'Antriebsschlupfregelung (ASR)',
      'Beifahrerairbags',
      'Bluetooth  USB',
      'Bordcomputer',
      'Dachreling',
      'elektr. Fensterheber',
      'elektr. Spiegel',
      'Fahrerairbag',
      'Freisprecheinrichtung',
      'ISOFIX',
      'Klimaanlage',
      'Klimaautomatik',
      'Lederlenkrad',
      'Leichtmetall-Alufelgen',
      'Lenkradheizung',
      'Lordosenstuctze',
      'Mittelarmlehne',
      'Multifunktionslenkrad',
      'Navigationssystem',
      'Nebelscheinwerfer',
      'Parksensor hinten',
      'Radio',
      'Regensensor',
      'Reifendrucksensor',
      'Seitenairbags',
      'Servicegepflegt',
      'Servolenkung',
      'Sitzheizung',
      'Spurhalteassistent',
      'Stabilitetsprogramme (ESP)',
      'Tagfahrlicht',
      'Tempomat',
      'Zentralverriegelung',
      'Metallic-Lackierung',
      'Kopfairbags',
      'Notrufsystem',
      'Parksensor vorne & hinten',
      'StartStopp-Automatik',
      'MwSt. ausweisbar',
      'LED-Scheinwerfer',
      'Winterpaket',
    ],
    description:
      '<p><strong>Terminvereinbarung für Besichtigung und Probefahrt unbedingt erforderlich*</strong></p><p><strong>* 1.BESITZ - NUR 154.000 KM SERVICEHEFT *</strong><br>* PICKERL NEU BIS 04/2024 + 4 MONATE *</p><p><strong>GTI, NAVI, RÜCKFAHRKAMERA, AMBIENTEBELEUCHTUNG,</strong> EINPARKSENSOREN, START-STOP AUTOMATIK, KLIMAAUTOMATIK, TEMPOMAT MIT GESCHWINDIGKEITSBEGRENZER, SERVO, ABS, ESP, EL.FH, ZV, EL.SP, RADIO, USB AUX, BLUETOOTH, MULTIFUNKTIONSLENKRAD, ALU usw...</p><p><strong>!!! SOFORT KREDIT !!!</strong><br>SCHON AB 1 MONAT BESCHÄFTIGUNG AUCH OHNE ANZAHLUNG MÖGLICH FAST ALLE GÄNGIGEN FINANZIERUNGSMODELLE, BEI PASSENDER BONITÄT ABWICKLUNG INNERHALB 24h</p><p><strong>** 50/50 FINANZIERUNG MIT 0% ZINSEN**</strong></p><p>Anhängerkupplung (Kugelkopf schwenkbar)<br>Audiosystem Composition Media (Touchscreen, Radio/CD-Player, MP3, Bluetooth)<br>Business-Paket Premium mit Navigation<br>Fahrassistenz-System: Parklenkassistent (Park Assist)<br>Lautsprecher (8)<br>Licht- und Sicht-Paket 1<br>LM-Felgen 7,5x18 (Milton Keynes, schwarz glanzgedreht)<br>Mobiltelefon Schnittstelle Comfort mit kabelloser Ladefunktion<br>Navigationsmodul Discover Media (für Audiosystem)<br>Radioempfang digital (DAB+)<br>Rückfahrkamera<br>Sonderlackierung Tornado-Rot uni<br>Verglasung hinten abgedunkelt (90 %)<br>3-Punkt-Sicherheitsgurt hinten mitte<br>Abbiegelicht<br>Airbag Beifahrerseite abschaltbar<br>Airbag Fahrer-/Beifahrerseite<br>Ambiente-Beleuchtung<br>Anti-Blockier-System (ABS)<br>Antriebs-Schlupfregelung (ASR)<br>Antriebsart: Frontantrieb<br>Ausstattung GTI<br>Auto-Hold-Funktion<br>Außenspiegel asphärisch, links<br>Außenspiegel elektr. verstell- und heizbar<br>Außenspiegel konvex, rechts<br>Außenspiegel lackiert<br>Außenspiegel mit autom. Absenkfunktion, rechts<br>Blinkleuchte in Außenspiegel integriert<br>Bremsassistent<br>Bremssättel Rot lackiert<br>Chrom-Paket 2<br>Dachhimmel Stoff, schwarz<br>Dachspoiler<br>Doppeltonhorn<br>Durchladeeinrichtung (Mittelarmlehne hinten)<br>Einstiegshilfe Easy-Entry<br>Einstiegsleisten vorn beleuchtet<br>Elektron. Differentialsperre (EDS)<br>Elektron. Differentialsperre (XDS)<br>Elektron. Stabilitäts-Programm (ESP)<br>Fahrassistenz-System: Anhänger-Stabilisierungs-Programm<br>Fahrassistenz-System: Müdigkeitserkennungs-Sensor<br>Fahrassistenz-System: Umfeldbeobachtungssystem (Front assist) mit City-Notbremsfunktion<br>Fensterheber elektrisch<br>Frontscheibe Verbundglas getönt<br>Funkschlüssel (2) klappbar<br>Getriebe 6-Gang<br>Handschuhfach mit Kühlung<br>Heckleuchten LED, dunkelrot, Blinkleuchten dynamisch<br>Heckscheibenwischer<br>Innenausstattung: Dekoreinlagen Honeycomb Black<br>Isofix-Aufnahmen für Kindersitz an Rücksitz<br>Karosserie: 3-türig<br>Klimaanlage Climatronic 2-Zonen<br>Knieairbag Fahrerseite<br>Kopf-Airbag-System vorn und hinten inkl. Seitenairbag vorn<br>Kopfstützen hinten (3-fach)<br>Lendenwirbelstütze Sitz vorn rechts<br>Lenkrad (Sport/Leder) mit Multifunktion<br>Lenksäule (Lenkrad) mechan. verstellbar, Höhen-/Längsverstellung<br>Leseleuchten vorn und hinten LED<br>Mittelarmlehne vorn<br>Modellpflege<br>Motor 2,0 Ltr. - 169 kW 16V T FSI KAT (CHHA)<br>Multifunktionsanzeige Premium (Farbdisplay)<br>Nebelschlussleuchte<br>Nichtraucher-Paket<br>Park-Distance-Control (vorn und hinten)<br>Parkbremse elektrisch<br>Pedale Edelstahl<br>Progressivlenkung<br>Reifen-Reparaturkit',
  },
  {
    id: 4,
    year: 2010,
    month: 10,
    body: 'Limousine',
    transmission: 'Hinterrad',
    mileage: 224000,
    fuel: 'Diesel',
    price: 18000,
    title: 'BMW 3er-Reihe 320i Gran Turismo Advantage * Automatik NUR 46 TKM',
    images: [
      'bmwgt_back.jpg',
      'bmwgt_dashboard.jpg',
      'bmw_frontgt.jpg',
      'bmwgt_interior.jpg',
    ],
    link: 'bmwgt.jpg',
    make: 'BMW',
    model: '520D',
    condition: 'NEU',
    drivetrain: 'Hinterrad',
    engine: '120KW',
     exterior: 'Grau',
    features: [
      'ABS',
      'Alarmanlage',
      'Antriebsschlupfregelung (ASR)',
      'Beifahrerairbags',
      'Bluetooth USB',
      'Bordcomputer',
      'elektr. Fensterheber',
      'elektr. Spiegel',
      'Fahrerairbag',
      'Freisprecheinrichtung',
      'ISOFIX',
      'Klimaanlage',
      'Klimaautomatik',
      'Kurvenfahrlicht',
      'Lederlenkrad',
      'Leichtmetall-Alufelgen',
      'Lichtsensor',
      'Lordosenstutze',
      'Media-Interface  mp3',
      'Mittelarmlehne',
      'Multifunktionslenkrad',
      'Navigationssystem',
      'Nebelscheinwerfer',
      'Notbremsassistent',
      'Parksensor hinten',
      'Radio',
      'Regensensor',
      'Reifendrucksensor',
      'Ruckfahrkamera',
      'Seitenairbags',
      'Servicegepflegt',
      'Servolenkung',
      'Sitzheizung',
      'Spurhalteassistent',
      'Stabilitetsprogramme (ESP)',
      'Tagfahrlicht',
      'Tempomat',
      'Zentralverriegelung',
      'Lederausstattung',
      'Metallic-Lackierung',
      'Sportfahrwerk',
      'Kopfairbags',
      'Panoramadach',
      'Schiebedach',
      'Anhngerkupplung',
      'Aut. Heckklappe',
      'Notrufsystem',
      'Parksensor vorne & hinten',
      'Schisack',
      'StartStopp-Automatik',
      'Kollisionswarner',
      'Handy induktiv laden',
      'Head-Up-Display',
      'Keyless entry',
      'Komfortfahrwerk',
      'LED-Scheinwerfer',
      'Totwinkelassistent',
    ],
    description:
      '<p>*Terminvereinbarung für Besichtigung und Probefahrt unbedingt erforderlich*</p><p> <strong>* 1.BESITZ - NUR 46.000 KM  SERVICEBUCH *</strong><br> * PICKERL NEU BIS 03 / 2024 + 4 MONATE *</p><p> <strong>AUTOMATIK , PARKSENSOREN ( VO & HI ) , START-STOP-SYSTEM , TEMPOMAT MIT GESCHWINDIGKEITSBEGRENZER , KLIMAAUTOMATIK ,</strong> SITZHEITZUNG , SERVO , ABS , ESP , EL.FH , ZV , EL.SP , RADIO , BERGANFAHRASSISTENT , USB AUX , BLUETOOTH , LED - TAGFAHRLICHT , MULTIFUNKTIONSLENKRAD XENON usw...</p><p> <strong>!!! SOFORT KREDIT !!!</strong><br> SCHON AB 1 MONAT BESCHÄFTIGUNG AUCH OHNE ANZAHLUNG MÖGLICH FAST ALLE GÄNGIGEN FINANZIERUNGSMODELLE, BEI PASSENDER BONITÄT ABWICKLUNG INERHALB 24h</p><p> <strong>50/50 FINANZIERUNG MIT 0% ZINSEN</strong></p><p> Ablage-Paket<br> Anhängerkupplung (Kugelkopf schwenkbar)<br> Instrumentenkombination (erweiterter Umfang)<br> Klimaautomatik 2-Zonen mit autom. Umluft-Control<br> Lendenwirbelstütze Sitz vorn links und rechts, elektr. verstellbar<br> Lenkrad (Leder) BMW Individual<br> Licht-Paket<br> LM-Felgen 7,5x17 (Sternspeiche 394)<br> Metallic-Lackierung<br> Park-Distance-Control (PDC) vorn und hinten<br> Reifensystem Run-Flat (mit Notlaufeigenschaften)<br> Scheinwerfer-Reinigungsanlage (SRA)<br> Sitzheizung vorn<br> Variable Sportlenkung<br> Advantage<br> Airbag Beifahrerseite abschaltbar<br> Airbag Fahrer-/Beifahrerseite<br> Aktive Motorhaube<br> Anti-Blockier-System (ABS)<br> Audiosystem BMW Professional (Radio/CD-Player MP3-fähig)<br> Auspuffanlage (1-Rohr-Anlage) mit Blende<br> AUX-IN-Anschluss (AUX-IN)<br> Außenspiegel elektr. verstell- und heizbar<br> Außenspiegel Wagenfarbe<br> Außentemperaturanzeige<br> Bordcomputer<br> Bremsassistent<br> Check-Control-System<br> Dynamische Bremsleuchte<br> Dynamische Stabilitäts-Control (DSC)<br> Dynamische Tractions Control (DTC)<br> Fahrassistenz-System: Fahrerlebnisschalter<br> Farbmonitor (6,5 Zoll)<br> Fensterheber elektrisch vorn + hinten<br> Fernentriegelung Heckklappe<br> Freisprecheinrichtung Bluetooth mit USB-/Audio-Schnittstelle<br> Fußmatten Velours<br> Gepäckraumabdeckung / Rollo<br> Geschwindigkeits-Begrenzeranlage (Speed Limit Device)<br> Geschwindigkeits-Regelanlage mit Bremsfunktion<br> Getriebe Automatik - (8-Stufen)<br> Getränkehalter<br> Heckklappenbetätigung automatisch<br> Heckleuchten LED<br> Heckscheibe mit Antenne<br> Innenausstattung: Interieurleisten Satin-Silber, matt<br> Isofix-Aufnahmen für Kindersitz<br> Isofix-Aufnahmen für Kindersitz an Rücksitz<br> Karosserie: 5-türig<br> Kopf-Airbag-System hinten<br> Kopf-Airbag-System vorn<br> Kopfstützen hinten klappbar<br> Lenksäule (Lenkrad) mechan. verstellbar<br> Licht- und Regensensor<br> LM-Felgen<br> Mittelarmlehne hinten<br> Mittelarmlehne vorn verstellbar<br> Modellpflege<br> Motor 2,0 Ltr. - 135 kW<br> Nebelscheinwerfer<br> Nebelscheinwerfer LED<br> Personalisierungssystem (Personal Profile)<br> Reifendruck-Kontrollsystem<br> Rücksitzlehne geteilt/klappbar (40:20:40)<br> Schadstoffarm nach Abgasnorm Euro 6<br> Scheibenwaschdüsen heizbar<br> Scheinwerfer LED<br> Seitenairbag hinten<br> Seitenairbag vorn<br> Service-System: Intelligenter Notruf inkl. TeleServices<br> Servolenkung Servotronic<br> Sitzbezug / Polsterung: Stoff Move<br> Sitze vorn höhen-/neigungsverstellbar<br> Start-Stop-Knopf<br> Start/Stop-Anlage (Funktion)<br> Steckdose (12V-Anschluss) zusätzlich<br> Tagfahrlicht LED<br> Wegfahrsperre<br> Wärmeschutzverglasung getönt<br> Zentralverriegelung mit Fernbedienung</p><p> !!! EINTAUSCH - UND FINANZIERUNGSMÖGLICHKEIT !!!<br> Irrtümer Zwischenverkauf Satz und Druckfehler vorbehalten',
  },
  {
    id: 5,
    year: 2016,
    month: 2,
    transmission: 'Hinterrad',
    mileage: 4000,
    body: 'Kombi',
     exterior: 'Weiß',
    price: 20000,
    title: 'Ford Galaxy Advantage Automatik Kombi Famil',
    link: 'ford.jpg',
    fuel: 'Benzin',
    images: [
      'ford_interior.jpg',
      'ford_front.jpg',
      'ford_dashboard.jpg',
      'ford_back.jpg',
    ],
    make: 'Ford',
    model: 'Galaxy',
    condition: 'NEU',
    drivetrain: 'front-wheel',
    engine: '90KW',
    features: [
      'ABS',
      'Antriebsschlupfregelung (ASR)',
      'Beifahrerairbags',
      'Bluetooth  USB',
      'Bordcomputer',
      'Dachreling',
      'elektr. Fensterheber',
      'elektr. Spiegel',
      'Fahrerairbag',
      'Freisprecheinrichtung',
      'ISOFIX',
      'Klimaanlage',
      'Lederlenkrad',
      'Leichtmetall-Alufelgen',
      'Media-Interface  mp3',
      'Multifunktionslenkrad',
      'Nebelscheinwerfer',
      'Notbremsassistent',
      'Radio',
      'Reifendrucksensor',
      'Seitenairbags',
      'Servicegepflegt',
      'Servolenkung',
      'Sitzheizung',
      'Stabilitetsprogramme (ESP)',
      'Tagfahrlicht',
      'Zentralverriegelung',
      'CD Player',
      'Kopfairbags',
      'StartStopp-Automatik',
    ],
    description:
      '<p>*Terminvereinbarung für Besichtigung und Probefahrt unbedingt erforderlich*</p><p> <strong>* 1.BESITZ - 144.000 KM *</strong><br> * PICKERL NEU BIS 08 / 2023 + 4 MONATE *</p><p> <strong>* MEHRWERTSTEUER AUSWEISBAR *</strong></p><p> <strong>AUTOMATIK , NAVI , RÜCKFAHRKAMERA , PARKSENSOREN ( VO & HI )</strong> , START-STOP-SYSTEM , KOLLISIONSWARNER ,TEMPOMAT MIT GESCHWINDIGKEITSBEGRENZER , KLIMAAUTOMATIK , SERVO , ABS , ESP , EL.FH , ZV , EL.SP , RADIO , BERGANFAHRASSISTENT , USB AUX , BLUETOOTH , LED - TAGFAHRLICHT , MULTIFUNKTIONSLENKRAD XENON usw...</p><p> <strong>!!! SOFORT KREDIT !!!</strong><br> SCHON AB 1 MONAT BESCHÄFTIGUNG AUCH OHNE ANZAHLUNG MÖGLICH FAST ALLE GÄNGIGEN FINANZIERUNGSMODELLE, BEI PASSENDER BONITÄT ABWICKLUNG INERHALB 24h</p><p> <strong>50/50 FINANZIERUNG MIT 0% ZINSEN</strong></p><p>Alpinweiß-Lackierung (Uni)<br> Außen-/Innenspiegel mit Abblendautomatik<br> Dachreling schwarz<br> Innenspiegel mit Abblendautomatik<br> Lendenwirbelstütze Sitz vorn links und rechts, elektr. verstellbar<br> Navigationssystem: Navigation (USB)<br> Park-Distance-Control (PDC) vorn und hinten<br> Reifen-Reparaturset (Mobility-Pack)<br> Rückfahrkamera<br> Spiegel-Paket<br> Uni-Lackierung<br> Ablage-Paket<br> Advantage<br> Airbag Beifahrerseite<br> Airbag Beifahrerseite abschaltbar<br> Airbag Fahrer-/Beifahrerseite<br> Airbag Fahrerseite<br> Anti-Blockier-System (ABS)<br> Auspuffanlage (1-Rohr-Anlage) mit Blende<br> Außenspiegel elektr. verstellbar<br> Außenspiegel Wagenfarbe<br> Außentemperaturanzeige<br> Bordcomputer<br> Bremsassistent<br> Check-Control-System<br> Diebstahlsicherung für Räder (Felgenschlösser)<br> Dynamische Bremsleuchte<br> Dynamische Stabilitäts-Control (DSC)<br> Dynamische Tractions Control (DTC)<br> Fahrassistenz-System: Auffahrwarnsystem mit Bremsfunktion<br> Fahrassistenz-System: Aufmerksamkeits-Assistent<br> Fahrassistenz-System: Fahrerlebnisschalter<br> Freisprecheinrichtung Bluetooth mit USB-/Audio-Schnittstelle<br> Fußmatten Velours<br> Gepäckraumabdeckung / Rollo<br> Geschwindigkeits-Regelanlage mit Bremsfunktion<br> Getriebe Automatik - (8-Stufen)</p><p>Harnstofftank (SCR): 12,5 Ltr.<br> Heckklappenbetätigung automatisch<br> Innenausstattung: Instrumententafel - unterhalb Piano Black<br> Isofix-Aufnahmen für Kindersitz an Rücksitz<br> Karosserie: 5-türig<br> Klimaautomatik 2-Zonen mit autom. Umluft-Control<br> Kopf-Airbag-System hinten<br> Kopf-Airbag-System vorn<br> Lenksäule (Lenkrad) mechan. verstellbar<br> Licht- und Regensensor<br> LM-Felgen<br> Mittelarmlehne hinten<br> Mittelarmlehne vorn<br> Modellpflege<br> Motor 1,5 Ltr. - 85 kW 12V Turbodiesel<br> Multifunktion für Lenkrad<br> Parkbremse elektrisch<br> Personalisierungssystem (Personal Profile)<br> Reifendruck-Kontrollsystem<br> Rußpartikelfilter<br> Rücksitzlehne geteilt/klappbar (40:20:40)<br> Schadstoffarm nach Abgasnorm Euro 6<br> Schadstoffarm nach Abgasnorm Euro 6d-TEMP</p><p>SCR-System (AdBlue-Technologie)<br> Seitenairbag hinten<br> Seitenairbag vorn<br> Service-System: ConnectedDrive Services<br> Service-System: Intelligenter Notruf inkl. TeleServices<br> Service-System: Remote Services<br> Servolenkung Servotronic<br> Sitzbezug / Polsterung: Stoff Grid<br> Sitze hinten mechanisch verstellbar<br> Sitze vorn mechanisch verstellbar<br> Start/Stop-Anlage (Funktion)<br> Steckdose (12V-Anschluss) in Mittelkonsole und Koffer-/Laderaum (4-fach)<br> Tagfahrlicht LED<br> Wegfahrsperre<br> Wärmeschutzverglasung getönt<br> Zentralverriegelung mit Fernbedienung</p><p><br> !!! EINTAUSCH - UND FINANZIERUNGSMÖGLICHKEIT !!!<br> Irrtümer Zwischenverkauf Satz und Druckfehler vorbehalten',
  },
];
